<app-breadcrumb [styleBreadcrumb]="'page-heading-blue'" [title]="'PROGRAMS'" [breadcrumb]="breadcrumb"
  [isStringLiteral]="stringLiteralBreadcrumb" [count]="channelCount" [countBgColor]="'#3a5161'" icon="fa-cubes">
</app-breadcrumb>
<!--Loading div-->
<div class="content-background">
  <div *ngIf="loading" class="page-wrap align-items-center mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col-md-6">
      <kendo-dropdownbutton *ngIf="!programDisabled" [data]="newProgramActions" textField="actionName">
        {{ 'CREATE-NEW-PROGRAM' | translate }}<i class="far fa-plus"></i>
      </kendo-dropdownbutton>
    </div>
    <div class="col-sm-6">
      <div class="float-right pr-2">
        <app-advanced-mode [storageKey]="'channels-list'" (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
      </div>
      <div class="float-right pr-4">
        <label class="control-label text-uppercase montserrat">
          {{'COLLAPSED' | translate}}
        </label>&nbsp;
        <kendo-switch [(ngModel)]="collapseAll" (valueChange)="onChangeCollapse($event)"></kendo-switch>
      </div>
    </div>
  </div>
  <div style="padding-left: 30px;"
    *ngxPermissionsOnly="['ROLE_PROGRAM_LEAD', 'ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR']">
    <div class="row" *ngIf="!loading">
      <!--Grouping panel-->
      <div *ngIf="enableAdvanced" class="col-md-12 card card-shadow card-filter-container mt-3 pb-1"
        style="margin-left:-15px">
        <form [formGroup]="filterForm" class="k-form">
          <div class="mt-2 row">
            <!--Group By-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="groupBy" class="w-100">
                <i class="fal fa-fw fa-folders"></i>
                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isGrouped}">
                  {{'PROGRAM-GROUP-BY' | translate}}
                </span>
                <kendo-combobox class="w-100" [data]="listGroupBy" [textField]="'text'" formControlName="groupBy"
                  [valueField]="'value'" [valuePrimitive]="true">
                </kendo-combobox>
              </span>
            </div>
            <!--Filter Category-->
            <div class="col-xl-3 col-lg-8 col-xs-12">
              <span for="filterByCategory" class="w-100">
                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isFiltered('filterByCategory')}">
                  <i class="fal fa-fw fa-filter"></i>
                  {{'PROGRAM-FILTER-CATEGORY' | translate}}
                </span>
                <kendo-multiselect [data]="programCategories" formControlName="filterByCategory" [textField]="'name'"
                  [valueField]="'id'" [autoClose]="true" [valuePrimitive]="true">
                  <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div class="m-1">
                      <input type="checkbox" [checked]="isFilterSelected('filterByCategory',dataItem.id)"
                        kendoCheckBox />
                      <label class="k-checkbox-label">{{ dataItem.name }}</label>
                    </div>
                  </ng-template>
                </kendo-multiselect>
              </span>
            </div>
            <!--Filter Status-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="filterByStatus" class="w-100">
                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isFiltered('filterByStatus')}">
                  <i class="fal fa-fw fa-filter"></i>
                  {{'PROGRAM-FILTER-STATUS' | translate}}
                </span>
                <kendo-multiselect [data]="channelStatuses" formControlName="filterByStatus" [textField]="'text'"
                  [valueField]="'value'" [autoClose]="true" [valuePrimitive]="true">
                  <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div class="m-1">
                      <input type="checkbox" [checked]="isFilterSelected('filterByStatus',dataItem.value)"
                        kendoCheckBox />
                      <label class="k-checkbox-label">{{ dataItem.text }}</label>
                    </div>
                  </ng-template>
                </kendo-multiselect>
              </span>
            </div>
            <!--Filter Performance-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="filterByPerformance" class="w-100">
                <span class="k-text-uppercase dark"
                  [ngClass]="{'active-filter-text': isFiltered('filterByPerformance')}">
                  <i class="fal fa-fw fa-filter"></i>
                  {{'PROGRAM-FILTER-PERFORMANCE' | translate}}
                </span>
                <kendo-multiselect [data]="channelPerformances" formControlName="filterByPerformance"
                  [textField]="'text'" [valueField]="'value'" [autoClose]="true" [valuePrimitive]="true">
                  <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div class="m-1">
                      <input type="checkbox" [checked]="isFilterSelected('filterByPerformance',dataItem.value)"
                        kendoCheckBox />
                      <label class="k-checkbox-label">{{ dataItem.text }}</label>
                    </div>
                  </ng-template>
                </kendo-multiselect>
              </span>
            </div>
          </div>
          <!--Sort by-->
          <div class="mt-2 row">
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="sortBy" class="w-100">
                <i class="fal fa-fw fa-sort"></i>
                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isSorted}">
                  {{'PROGRAM-SORT-BY' | translate}}
                </span>
                <kendo-combobox class="w-100" [data]="channelSorts" [textField]="'text'" formControlName="sortBy"
                  [valueField]="'value'" [valuePrimitive]="true">
                </kendo-combobox>
              </span>
            </div>
            <!--Sort direction-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="sortDirection" *ngIf="isSorted">
                <i *ngIf="sortDirection.value === 'asc'" class="far fa-sort-amount-up"></i>
                <i *ngIf="sortDirection.value === 'desc'" class="far fa-sort-amount-down"></i>
                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isSorted}">
                  {{'SORT-DIRECTION' | translate}}
                </span>
                <br />
                <div class="mt-2">
                  <input type="radio" value="asc" name="sortDirection" formControlName="sortDirection"
                    id="radioAscending" kendoRadioButton />
                  <label class="k-radio-label" for="radioAscending">{{'SORT-ASCENDING' | translate}}</label>
                  <input type="radio" value="desc" name="sortDirection" formControlName="sortDirection"
                    id="radioDescending" kendoRadioButton />
                  <label class="k-radio-label" for="radioDescending">{{'SORT-DESCENDING' | translate}}</label>
                </div>
              </span>
            </div>
            <!--Filter Program Name-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="filterByProgramName" class="w-100">
                <span class="k-text-uppercase dark"
                  [ngClass]="{'active-filter-text': isFiltered('filterByProgramName')}">
                  <i class="fal fa-fw fa-filter"></i>
                  {{'PROGRAM-FILTER-PROGRAM-NAME' | translate}}
                </span>
                <input kendoTextBox formControlName="filterByProgramName" class="w-100" />
              </span>
            </div>
            <!--Filter Channel Name-->
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <span for="filterByChannelName" class="w-100">
                <span class="k-text-uppercase dark"
                  [ngClass]="{'active-filter-text': isFiltered('filterByChannelName')}">
                  <i class="fal fa-fw fa-filter"></i>
                  {{'PROGRAM-FILTER-CHANNEL-NAME' | translate}}
                </span>
                <input kendoTextBox formControlName="filterByChannelName" class="w-100" />
              </span>
            </div>
          </div>
          <div class="mt-2 row">
            <div class="col-xl-3 col-lg-4 col-xs-12"></div>
            <div class="col-xl-3 col-lg-4 col-xs-12"></div>
            <div class="col-xl-3 col-lg-4 col-xs-12">
              <label class="mb-0">
                <span class="k-text-uppercase dark">
                  {{'VIEW' | translate}}
                </span>
                <br />
                <div class="mt-2">
                  <app-list-mode #listMode [defaultMode]="'list'" [contextMode]="'card'" [storageKey]="storageView"
                    [titleKey]="''" (collapsibleToggle)="assignView($event)">
                  </app-list-mode>
                  <input type="hidden" value="{{channelViewType}}" name="typeView" formControlName="typeView"
                    id="typeView" />
                </div>
              </label>
            </div>
            <!--Clear and Save filter-->
            <div class="col-xl-3 col-lg-4 col-xs-12 text-right" *ngIf="showFilterBtnActions" style="margin:auto;">
              <i class="far fa-fw fa-times-circle fa-delete-custom mr-3" title="{{'CLEAR-ALL-FILTER' | translate}}"
                (click)="clearFilters()" style="font-size:20pt" tabindex="0" (keydown.enter)="clearFilters()"
                (keydown.space)="clearFilters()">
              </i>
              <button kendoButton style="margin-top:-10px;" (click)="openFilterScreen()">{{ 'SAVE-FILTER' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div *ngIf="resumeFilters !== ''" class="row w-100 mt-4">
        <span class="k-text-uppercase">{{'RESULTS-FOR' | translate}} {{resumeFilters}}</span>
        <hr>
      </div>
      <!--Is Channel grouped?-->
      <div [ngSwitch]="isGrouped" class="w-100">
        <!--Render by selected group-->
        <div *ngSwitchCase="true" class="mt-4">
          <!--Show No Channel to display when all filtered-->
          <div class="row w-100 ml-2 mr-2" *ngIf="channelViewType === 'list'">
            <ng-template [ngTemplateOutlet]="titlesTemplate" [ngTemplateOutletContext]="{groupBy: groupBy.value}">
            </ng-template>
          </div>
          <div *ngFor="let groupedChannel of groupedChannels;let groupIndex = index">
            <div class="row" *ngIf="channelViewType === 'card'">
              <div class="col-xl-4 col-md-6 col-xs-12 pt-3 pb-3 d-flex" *ngFor="let channel of groupedChannel.channels">
                <ng-template [ngTemplateOutlet]="channelCardTemplate" [ngTemplateOutletContext]="{channel:channel}">
                </ng-template>
              </div>
            </div>
            <div class="row" *ngIf="channelViewType === 'list'">
              <div class="col-12 d-flex">
                <ng-template [ngTemplateOutlet]="totalsTemplate"
                  [ngTemplateOutletContext]="{totals:groupedChannel.totals, total: groupedChannel.channels.length, group: groupedChannel.group}">
                </ng-template>
              </div>
              <div class="col-12 d-flex vertical-line pr-4" *ngFor="let channel of groupedChannel.channels">
                <ng-template [ngTemplateOutlet]="channelListTemplate" [ngTemplateOutletContext]="{channel:channel}"
                  *ngIf="!collapsedSections[groupedChannel.group]">
                </ng-template>
              </div>
            </div>
          </div>
          <!--Show No Channel to display when all filtered-->
          <div class="mt-4" *ngIf="groupedChannels.length === 0" style="color: rgba(0, 0, 0, 0.25);">{{'NO-PROGRAMS' |
            translate }}</div>
        </div>
        <!--Render without a group-->
        <div *ngSwitchCase="false">
          <div class="row w-100 ml-2 mr-2 mt-4" *ngIf="channelViewType === 'list'">
            <ng-template [ngTemplateOutlet]="titlesTemplate" [ngTemplateOutletContext]="{groupBy: groupBy.value}">
            </ng-template>
          </div>
          <div class="row mt-2" *ngIf="channelViewType === 'card'">
            <div class="col-xl-4 col-md-6 col-xs-12 pt-3 pb-3 d-flex" *ngFor="let channel of channels">
              <ng-template [ngTemplateOutlet]="channelCardTemplate" [ngTemplateOutletContext]="{channel:channel}">
              </ng-template>
            </div>
          </div>
          <div class="row" *ngIf="channelViewType === 'list'">
            <div class="col-12 d-flex">
              <ng-template [ngTemplateOutlet]="totalsTemplate"
                [ngTemplateOutletContext]="{totals:channelTotals, total: channels.length}">
              </ng-template>
            </div>
            <div class="col-12 d-flex vertical-line" *ngFor="let channel of channels">
              <ng-template [ngTemplateOutlet]="channelListTemplate" [ngTemplateOutletContext]="{channel:channel}">
              </ng-template>
            </div>
          </div>
          <!--Show No Channel to display when all filtered-->
          <div class="mt-4" *ngIf="channels.length === 0" style="color: rgba(0, 0, 0, 0.25);">{{'NO-PROGRAMS' |
            translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Channels Template-->
<ng-template #channelListTemplate let-channel='channel'>
  <div class="h-100 w-100 p-1">
    <div [ngClass]="{'card':true, 'card-shadow':true, 'h-100':true, 'text-center':true, 'w-100':true}">
      <!--Channel-->
      <div class="card-body d-flex justify-content-center">
        <div *ngIf="middleLoading" class="row">
          <div class="col my-auto">
            <span class="k-icon k-i-loading kendo-loading-icon"></span>
          </div>
        </div>
        <div *ngIf="!middleLoadling" class="row w-100 d-flex align-items-center">
          <div class="col-5 my-auto">
            <div class="row h-100 pl-1">
              <div class="col-1 text-center my-auto">
                <div class="highlight-color-hover" [ngClass]="['rounded-large-icon', channel.backgroundClass]"
                  title="{{channel.status | uppercase | translate}}">
                  <span class="ml-2 badge badge-pill label-1 text-uppercase" [ngClass]="{
                                      'channel-status-offline': channel.status === 'Offline',
                                      'channel-status-simulated': channel.status === 'Simulated', 
                                      'channel-status-online': channel.status === 'Online',
                                      'channel-status-deleted': channel.status === 'Deleted',
                                      'channel-status-template': channel.status === 'Template',
                                      'channel-status-archived': channel.status === 'Archived'}">
                  </span>
                </div>
              </div>
              <div class="col-11">
                <div class="row" [ngClass]="{'h-100': groupBy.value === 'program'}">
                  <div class="col text-left font-weight-bold my-auto" style="margin-top: auto;">
                    <a [routerLink]="['/channel-detail', channel.id]" class="pointer label-name montserrat"
                      aria-describedby="program-channel"
                      title="{{'CHANNEL-OVERVIEW' | translate}} - {{channel.name}} ({{channel.category}})">
                      {{channel.name}}
                    </a>
                  </div>
                </div>
                <div class="row" *ngIf="groupBy.value !== 'program'">
                  <div class="col text-left label-program-lead my-auto keyboard-accessible"
                    style="margin-bottom: auto;">
                    {{'PROGRAM-LEAD' | translate}}:&nbsp;
                    <a class="pointer" (click)="sendMessageToProgramLead(channel)" tabindex="0"
                      (keydown.enter)="sendMessageToProgramLead(channel)"
                      (keydown.space)="sendMessageToProgramLead(channel)">{{channel.leader}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3 my-auto">
            <div class="row">
              <div class="col-4 my-auto">
                <div class="text-uppercase label-performance montserrat">
                  <a *ngIf="channel.statistics?.openCases > 0" [routerLink]="['/cases/active']" aria-describedby="cases"
                    [queryParams]="{channel: channel.id, allAssignee: true}" class="pointer">
                    <div>
                      {{channel.statistics?.openCases | roundNumber}}
                    </div>
                    <div class="label-performance-count" style="color: #527186">
                      {{'OPEN' | translate}}
                    </div>
                  </a>
                  <span *ngIf="channel.statistics?.openCases === 0">
                    <div>
                      {{channel.statistics?.openCases | roundNumber}}
                    </div>
                    <div class="label-performance-count">
                      {{'OPEN' | translate}}
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-4 my-auto">
                <div class="text-uppercase label-performance montserrat">
                  <a *ngIf="channel.statistics?.closedCases > 0" [routerLink]="['/cases/all']" aria-describedby="cases"
                    [queryParams]="{channel: channel.id, allAssignee: true, closedCases: true}" class="pointer">
                    <div>
                      {{channel.statistics?.closedCases | roundNumber}}
                    </div>
                    <div class="label-performance-count" style="color: #527186">
                      {{'CLOSED' | translate}}
                    </div>
                  </a>
                  <span *ngIf="channel.statistics?.closedCases === 0">
                    <div>
                      {{channel.statistics?.closedCases | roundNumber}}
                    </div>
                    <div class="label-performance-count">
                      {{'CLOSED' | translate}}
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-4 my-auto">
                <div class="text-uppercase label-performance montserrat">
                  <a *ngIf="channel.statistics?.lateTasks > 0" [routerLink]="['/tasks/active']" aria-describedby="tasks"
                    [queryParams]="{channel: channel.id, allAssignee: true }" class="pointer text-alert">
                    <div>
                      {{channel.statistics?.lateTasks | roundNumber}}
                    </div>
                    <div class="label-performance-count text-alert">
                      {{'LATE' | translate}}
                    </div>
                  </a>
                  <span *ngIf="channel.statistics?.lateTasks === 0">
                    <div>
                      {{channel.statistics?.lateTasks | roundNumber}}
                    </div>
                    <div class="label-performance-count">
                      {{'LATE' | translate}}
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <kendo-chart style="position: absolute; height: 35px; width: 100%;" *ngIf="channel.statistics?.goal > 0"
              aria-describedby="performance">
              <kendo-chart-area opacity="0"></kendo-chart-area>
              <kendo-chart-tooltip format='{0}%'></kendo-chart-tooltip>
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="[labelTeam]">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-series>
                <kendo-chart-series-item type="bullet"
                  [data]="[[channel.statistics?.performance, channel.statistics?.goal]]" [color]="barColor" [gap]="0.5">
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-tooltip>
                <ng-template kendoChartSeriesTooltipTemplate let-value="value">
                  {{'TARGET' | translate}} : {{channel.statistics?.goal | roundNumber}}%
                  <br />
                  {{'PERFORMANCE' | translate}}: {{channel.statistics?.performance | roundNumber}}%
                </ng-template>
              </kendo-chart-tooltip>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [majorGridLines]="hidden" [minorTicks]="hidden" [min]="0" [max]="100"
                  [visible]="false">
                  <kendo-chart-category-axis-item-labels format="{0}%">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
            </kendo-chart>
            <div class="text-uppercase label-total montserrat" *ngIf="channel.statistics?.goal === 0">
              {{'NO-TARGET-DEFINED' | translate}}
            </div>
          </div>
          <div class="col-1 text-uppercase label-total montserrat">
            {{channel.status | uppercase | translate}}
          </div>
          <div class="col-1 my-auto">
            <div ngbDropdown class="d-inline-block w-100" container="body">
              <button class="btn btn-outline-primary k-text-uppercase pl-0" id="dropdownProgramOptions"
                ngbDropdownToggle><i class="far fa-ellipsis-v fa-1_5x pointer" style="color: grey;"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownProgramOptions">
                <button class="dropdown-item k-text-uppercase" [routerLink]="['/channel-edit/' + channel.id]"
                  ngbDropdownItem>
                  <i class="fas fa-edit fa-header-nav-icon fa-fw"></i>{{ 'EDIT' | translate }}
                </button>
                <button class="dropdown-item k-text-uppercase" *ngIf="channel.deployedBpmKey !== null"
                  (click)="channelStatusDialog = true; selectedChannel = channel" ngbDropdownItem>
                  <i class="fas fa-toggle-on fa-header-nav-icon fa-fw"></i>{{ 'UPDATE-STATUS' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #channelCardTemplate let-channel='channel'>
  <div class="card flex-fill card-shadow">
    <div class="highlight-color-hover"
      [ngClass]="['card-header', 'text-center', 'pointer', 'header-white', channel.backgroundClass]"
      [routerLink]="['/channel-detail', channel.id]"
      title="{{'CHANNEL-OVERVIEW' | translate}} - {{channel.name}} ({{channel.category}})">
      <h4 class="montserrat k-text-ellipsis">{{channel.name}}</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col text-center">
          <h5 class="card-title"><i class="fal fa-folder-open"></i>&nbsp;{{'OPEN-CASES' | translate}}</h5>
          <h2>{{channel.statistics?.openCases | roundNumber}}</h2>
        </div>
        <div class="col text-center">
          <h5 class="card-title"><i class="fal fa-folder-open"></i>&nbsp;{{'CLOSED-CASES' | translate}}</h5>
          <h2>{{channel.statistics?.closedCases | roundNumber}}</h2>
        </div>
        <div class="col text-center">
          <h5 class="card-title"><i class="fal fa-tasks"></i>&nbsp;{{'OVERDUE-TASKS' | translate}}</h5>
          <h2>{{channel.statistics?.lateTasks | roundNumber}}</h2>
        </div>
      </div>
      <br>
      <div>
        <h5 class="pl-3"><i class="fal fa-bullseye-arrow"></i>&nbsp;{{'AVERAGE-DAYS-TO-CLOSE' | translate}}</h5>
        <div class="row no-gutters">
          <div class="col-sm-10">
            <kendo-chart class="small-bar-chart">
              <kendo-chart-area opacity="0"></kendo-chart-area>
              <kendo-chart-axis-defaults [majorTicks]="{visible: false}" [labels]="{visible: false}">
              </kendo-chart-axis-defaults>
              <kendo-chart-series>
                <kendo-chart-series-item type="bullet" [color]="channel.color"
                  [data]="[channel.statistics?.averageDaysToCloseCase, channel.statistics?.targetDaysToCloseCase]">
                </kendo-chart-series-item>
                <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [majorUnit]="channel.bulletGraphAxis.max"
                    [min]="channel.bulletGraphAxis.min" [max]="channel.bulletGraphAxis.max">
                  </kendo-chart-value-axis-item>
                </kendo-chart-value-axis>
              </kendo-chart-series>
              <kendo-chart-tooltip>
                <ng-template kendoChartSeriesTooltipTemplate let-value="value">
                  {{'TARGET' | translate}} : {{channel.statistics?.targetDaysToCloseCase | roundNumber}}
                  <br />
                  {{'CURRENT-AVERAGE' | translate}}: {{channel.statistics?.averageDaysToCloseCase | roundNumber}}
                </ng-template>
              </kendo-chart-tooltip>
            </kendo-chart>
          </div>
          <div class="col-sm-2 text-center">
            <h2 [ngStyle]="{'color': channel.color}">{{channel.statistics?.averageDaysToCloseCase | roundNumber}}</h2>
          </div>
        </div>
      </div>
      <br>
      <div class="text-center">
        <div class="highlight-color-hover" [ngClass]="['rounded-large-icon', 'pointer', channel.backgroundClass]"
          title="{{'EDIT-CHANNEL' | translate}}" [routerLink]="['/channel-edit/' + channel.id]">
          <i class="fal fa-pencil-alt"></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #totalsTemplate let-totals='totals' let-total='total' , let-group='group'>
  <div class="h-100" class="w-100">
    <!--Program-->
    <div>
      <div *ngIf="middleLoading" class="row">
        <div class="col my-auto">
          <span class="k-icon k-i-loading kendo-loading-icon"></span>
        </div>
      </div>
      <div *ngIf="!middleLoadling" class="row w-100 d-flex align-items-center">
        <div class="col-5 my-auto">
          <div class="row h-100 mt-2">
            <div class="col">
              <div *ngIf="groupBy.value === 'program'">
                <div class="row">
                  <div class="col text-justify my-auto label-channel montserrat pl-0 pointer" style="margin-top: auto;"
                    [routerLink]="['/program-detail', totals.programId]"
                    title="{{'PROGRAM-OVERVIEW' | translate}} - {{totals.programName}}"
                    aria-describedby="program-channel" role="link">
                    {{totals.programName}}
                    <span class="badge badge-pill badge-secondary ml-2 badge-program">
                      {{total}}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div *ngIf="groupBy.value === 'program'" id="program-lead"
                    class="col text-justify my-auto label-total montserrat pl-0 text-uppercase"
                    style="margin-bottom:auto;font-size:smaller;">
                    {{'PROGRAM-LEAD' | translate}}:&nbsp;
                    <a (click)="sendMessageToProgramLead(totals.leaderUserName)" tabindex="0"
                      (keydown.enter)="sendMessageToProgramLead(totals.leaderUserName)"
                      (keydown.space)="sendMessageToProgramLead(totals.leaderUserName)" class="pointer text-uppercase"
                      aria-describedby="program-lead">{{totals.programLead}}</a>
                  </div>
                </div>
              </div>
              <div *ngIf="groupBy.value !== 'program' && groupBy.value !== undefined && group !== undefined">
                <div class="row mb-2">
                  <div class="col text-justify my-auto label-channel montserrat pl-0 collapsible-text"
                    style="margin-top: auto;" (click)="programToggle(group)">
                    {{group | splitString: '|' : 0}}
                  </div>
                </div>
              </div>
              <div *ngIf="groupBy.value === undefined">
                <div class="row mb-2">
                  <div class="col text-justify my-auto label-channel montserrat pl-0" style="margin-top: auto;">
                    {{'TOTAL' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 my-auto">
          <div class="row">
            <div class="col-3 my-auto text-center text-uppercase label-total montserrat">
              <span [ngClass]="{'label-with-datas': totals.openCases > 0}">
                {{totals.openCases | roundNumber}} {{'OPEN' | translate}}
              </span>
            </div>
            <div class="col-3 my-auto text-center text-uppercase label-total montserrat">
              <span [ngClass]="{'label-with-datas': totals.closedCases > 0}">
                {{totals.closedCases | roundNumber}} {{'CLOSED' | translate}}
              </span>
            </div>
            <div class="col-3 my-auto text-center text-uppercase label-total montserrat">
              <span [ngClass]="{'text-alert': totals.lateTasks > 0}">
                {{totals.lateTasks | roundNumber}} {{'LATE' | translate}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-3 my-auto text-right">
          <div class="row">
            <div class="col-10 my-auto pr-0" *ngIf="groupBy.value === 'program'">
              <div ngbDropdown class="d-inline-block w-100" container="body">
                <button class="btn btn-outline-primary k-text-uppercase" id="dropdownProgramOptions"
                  ngbDropdownToggle><i class="far fa-ellipsis-v fa-1_5x pointer" style="color: grey;"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownProgramOptions">
                  <button class="dropdown-item k-text-uppercase" [routerLink]="['/program-edit/' + totals.programId]"
                    ngbDropdownItem>
                    <i class="fas fa-edit fa-header-nav-icon fa-fw"></i>{{ 'EDIT' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-2 my-auto" [ngClass]="{'col-12': groupBy.value !== 'program'}" *ngIf="isGrouped">
              <app-collapsible #collapsibles [useSessionStorage]="true" [storageKey]="'program-list-' + group"
                [updateCollapse]="collapseAll" (collapsibleToggle)="updateProgramCollapse(group, $event)">
              </app-collapsible>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #titlesTemplate let-groupBy='groupBy'>
  <div class="col-4 text-center pl-0">
    <span class="text-uppercase label-title montserrat" id="program-channel">{{(groupBy === 'program' ?
      'PROGRAM-CHANNEL' : 'CHANNEL') |
      translate }}
    </span>
  </div>
  <div class="col-3 text-center pl-0">
    <span class="text-uppercase label-title montserrat" id="cases">{{'CASES' | translate}}</span>
  </div>
  <div class="col-1 pl-0">
    <span class="text-uppercase label-title montserrat" id="tasks">{{'TASKS' | translate}}</span>
  </div>
  <div class="col-4 pl-0">
    <span class="text-uppercase label-title montserrat" id="performance">{{'PERFORMANCE' | translate}}</span>
  </div>
</ng-template>

<!--Save filter-->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Program'" [filterState]="filterForm.value"
  (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
</app-save-filter>

<!-- message dialog-->
<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
  <kendo-dialog-titlebar>
    <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="" [caseId]=""
    [messageList]="" [fromMessagesScreen]="'program-list'" [sendTo]="messageSendTo"
    (afterSave)="messageDialogOpened = false;" (saving)="savingMessage=$event;messageDialogOpened=false">
  </app-message-compose>
  <kendo-dialog-actions>
    <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
      }}</button>
    <button appPreventClick #submitButton kendoButton type="button"
      [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
      {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-channel-status [dialogOpened]="channelStatusDialog" [channel]="selectedChannel"
  (closing)="channelStatusDialog = false" (save)="channelStatusDialog = false; refreshProgramList()">
</app-channel-status>

<app-program-wizard #newProgramWizard></app-program-wizard>